export default __webpack_public_path__ + "static/nkfi-916c1a53634f7c68537439dd248820fd.jpg";